"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equals = void 0;
const equals = (a, b, respectArrayOrder = false) => {
    if (a === b)
        return true;
    if (a instanceof Date && b instanceof Date)
        return a.getTime() === b.getTime();
    if (!a || !b || (typeof a !== "object" && typeof b !== "object"))
        return a === b;
    if (a === null || a === undefined || b === null || b === undefined)
        return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length)
        return false;
    if (Array.isArray(a) && Array.isArray(b) && !respectArrayOrder) {
        return a.every((el) => b.includes(el));
    }
    return keys.every((k) => (0, exports.equals)(a[k], b[k], true));
};
exports.equals = equals;
//# sourceMappingURL=equals.js.map